import { AfterViewInit, Component, inject } from '@angular/core';
import {
  FormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  addMonths,
  endOfMonth,
  startOfMonth,
  startOfToday,
  subMonths,
} from 'date-fns';
import { Subject } from 'rxjs';
import { PayeeButtonComponent } from '../../../../shared/payee-buttons/payee-button/payee-button.component';
import { PayeeFormFieldComponent } from '../../../../shared/payee-form-fields/payee-form-field/payee-form-field.component';
import { PayeeDatepickerComponent } from '../../../../shared/payee-form-fields/payee-datepicker/payee-datepicker.component';
import { CaseStartsTableComponent } from './case-starts-table/case-starts-table.component';
import { CaseStartsByLawFirmTableComponent } from './case-starts-by-law-firm-table/case-starts-by-law-firm-table.component';
import { CaseFeesTableComponent } from './case-fees-table/case-fees-table.component';

@Component({
  selector: 'app-case-starts',
  templateUrl: './case-starts.component.html',
  styleUrls: ['./case-starts.component.scss'],
  imports: [
    PayeeButtonComponent,
    FormsModule,
    ReactiveFormsModule,
    PayeeFormFieldComponent,
    PayeeDatepickerComponent,
    CaseStartsTableComponent,
    CaseStartsByLawFirmTableComponent,
    CaseFeesTableComponent,
  ],
})
export class CaseStartsComponent implements AfterViewInit {
  private fb = inject(FormBuilder);

  readonly filterForm = this.fb.group({
    from_date: this.fb.control<Date>(startOfMonth(subMonths(new Date(), 1)), {
      validators: Validators.required,
      nonNullable: true,
    }),
    to_date: this.fb.control<Date>(endOfMonth(subMonths(new Date(), 1)), {
      validators: Validators.required,
      nonNullable: true,
    }),
  });

  loading = 0;
  readonly refresh = new Subject<void>();

  get from_date() {
    return this.filterForm.controls.from_date;
  }
  get to_date() {
    return this.filterForm.controls.to_date;
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.refresh.next());
  }

  addMonths(count: number): void {
    const fromDate = this.from_date.value;
    if (fromDate instanceof Date) {
      this.from_date.patchValue(startOfMonth(addMonths(fromDate, count)));
    } else {
      this.from_date.patchValue(startOfMonth(new Date()));
    }

    const toDate = this.to_date.value;
    if (toDate instanceof Date) {
      this.to_date.patchValue(endOfMonth(addMonths(toDate, count)));
    } else {
      this.to_date.patchValue(startOfToday());
    }
  }

  quickFilter(type: 'current_month' | 'prev_month' | 'ytd'): void {
    if (type === 'current_month') {
      this.from_date.patchValue(startOfMonth(new Date()));
      this.to_date.patchValue(startOfToday());
    } else if (type === 'prev_month') {
      this.from_date.patchValue(startOfMonth(subMonths(new Date(), 1)));
      this.to_date.patchValue(endOfMonth(subMonths(new Date(), 1)));
    } else if (type === 'ytd') {
      this.from_date.patchValue(new Date(new Date().getFullYear(), 0, 1));
      this.to_date.patchValue(startOfToday());
    }
  }

  updateLoading(loading: boolean): void {
    if (loading) {
      this.loading += 1;
    } else {
      this.loading -= 1;
    }
  }
}
